import { Component, Input, inject } from '@angular/core';
import { Evenement } from '../../models/evenement.class';
import { DatePipe, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-carte-agenda',
  imports: [NgStyle, RouterLink, DatePipe],
  templateUrl: './carte-agenda.component.html',
  styleUrl: './carte-agenda.component.scss'
})
export class CarteAgendaComponent {
  @Input() evenement?: Evenement;
  randomRotation: number = Math.floor(Math.random() * 10) - 5;
  
  private apiService = inject(ApiService);

  getImageUrl(url: string): string {
    return this.apiService.getImageUrl(url);
  }
}
